import BoardDetailContent, {
  BoardDetailContentProps,
} from '@/components/Board/BoardDetail/Content/BoardDetailContent';
import React from 'react';

const BoardAndRecord = ({
  content,
  searchText = '',
  focusedResultId,
  hoveredResultId,
  scrollTrigger,
}: BoardDetailContentProps) => {
  return (
    <div>
      <BoardDetailContent
        content={content}
        searchText={searchText}
        focusedResultId={focusedResultId}
        hoveredResultId={hoveredResultId}
        scrollTrigger={scrollTrigger}
      />
    </div>
  );
};
export default BoardAndRecord;
